/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RemoveCountryManagerRequest
 */
export interface RemoveCountryManagerRequest {
    /**
     * 
     * @type {string}
     * @memberof RemoveCountryManagerRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof RemoveCountryManagerRequest
     */
    managerId: string;
}

/**
 * Check if a given object implements the RemoveCountryManagerRequest interface.
 */
export function instanceOfRemoveCountryManagerRequest(value: object): value is RemoveCountryManagerRequest {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('managerId' in value) || value['managerId'] === undefined) return false;
    return true;
}

export function RemoveCountryManagerRequestFromJSON(json: any): RemoveCountryManagerRequest {
    return RemoveCountryManagerRequestFromJSONTyped(json, false);
}

export function RemoveCountryManagerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RemoveCountryManagerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'managerId': json['managerId'],
    };
}

export function RemoveCountryManagerRequestToJSON(value?: RemoveCountryManagerRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
        'managerId': value['managerId'],
    };
}

